import { render, staticRenderFns } from "./xmcbjsmx.vue?vue&type=template&id=1f585857&scoped=true&"
import script from "./xmcbjsmx.vue?vue&type=script&lang=js&"
export * from "./xmcbjsmx.vue?vue&type=script&lang=js&"
import style0 from "./xmcbjsmx.vue?vue&type=style&index=0&id=1f585857&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f585857",
  null
  
)

export default component.exports